import React from 'react';

import BarraSeccion from './BarraSeccion';
import Loader from './Loader';

// Página de lista para las vistas sin vista previa: barra de sección, buscador y filas (children).
// margen: ancho del panel de edición abierto, para que la lista ocupe el resto.
// En listas paginadas por la API: conteo (texto del total), filtros, migas (ruta de carpetas) y pie (paginación)
const ListaAdmin = ({ etiqueta, encabezado, ayuda, acciones, aviso, migas, filtros, busqueda, onBusqueda, placeholder, total, mostrados, conteo, cargando, actualizando, textoVacio, pie, margen = 0, children }) => (
    <div id='vistas_generales' className='col s12' style={{padding:"0", width: margen ? `calc(100% - ${margen}px)` : undefined}}>
        <BarraSeccion etiqueta={etiqueta} encabezado={encabezado} ayuda={ayuda} acciones={acciones} />
        <div className='lista_admin'>
            {migas}
            {aviso && <p className='lista_admin_aviso'>{aviso}</p>}
            <div className='lista_admin_herramientas'>
                <label className='lista_admin_buscador'>
                    <i className='material-icons'>search</i>
                    <input
                        type='search'
                        className='browser-default'
                        value={busqueda}
                        onChange={e => onBusqueda(e.target.value)}
                        placeholder={placeholder}
                        aria-label={placeholder}
                    />
                </label>
                {!cargando && (
                    <span className='lista_admin_conteo'>
                        {conteo ?? (busqueda.trim() ? `${mostrados} de ${total}` : `${total} en total`)}
                    </span>
                )}
            </div>
            {filtros && <div className='lista_admin_filtros'>{filtros}</div>}
            {cargando ? (
                <div className='lista_admin_estado'><Loader /></div>
            ) : mostrados === 0 ? (
                <p className='lista_admin_estado'>
                    {busqueda.trim() ? `No hay resultados para "${busqueda.trim()}".` : textoVacio}
                </p>
            ) : (
                <ul className={'lista_admin_filas' + (actualizando ? ' lista_admin_actualizando' : '')}>{children}</ul>
            )}
            {!cargando && pie}
        </div>
    </div>
);

export default ListaAdmin;
